import { graphql } from "@/lib/gql/__generated__/gql";

export const PlanDelete_PlanListPage_Mutation = graphql(/* GraphQL */ `
	mutation PlanDelete_PlanListPage($hotelID: ID!, $planID: ID!) {
		planDelete(hotelID: $hotelID, planID: $planID) {
			userErrors
			message
		}
	}
`);
